/**
 * Reshapes webshop's JS-rendered product cards into the marketplace layout,
 * without forking the webshop app.
 *
 * webshop assigns `webshop.ProductGrid` at bundle load. This file loads after
 * it (required_apps puts webshop first in the asset order), so we patch the
 * prototype in place. Methods we do not touch keep flowing from upstream, so
 * a webshop upgrade only breaks us if it changes one of these five methods.
 */

(function patch_product_cards() {
	if (!window.webshop || !webshop.ProductGrid) {
		// Bundle order surprised us — try again once the DOM is up.
		return frappe.ready
			? frappe.ready(() => setTimeout(patch_product_cards, 0))
			: null;
	}

	const Grid = webshop.ProductGrid.prototype;

	/* --- card wrapper: drop the bootstrap column, the CSS grid handles it --- */
	Grid.make = function () {
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title = title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="item-card">
				<div class="card">
					${ this.get_image_html(item, title) }
					${ this.get_card_body_html(item, title, this.settings) }
				</div>
			</div>`;
		});

		this.products_section.append(html);
	};

	/* --- image, with the badge and heart as overlays --- */
	Grid.get_image_html = function (item, title) {
		const media = item.website_image
			? `<img itemprop="image" class="card-img" src="${ item.website_image }" alt="${ title }" loading="lazy">`
			: `<div class="card-img-top no-image">${ frappe.get_abbr(title) }</div>`;

		let overlays = this.get_discount_badge(item);

		if (!item.has_variants) {
			if (this.settings.enable_wishlist) overlays += this.get_wishlist_icon(item);
			if (this.settings.enabled) overlays += this.get_cart_indicator(item);
		}

		return `
			<div class="card-img-container">
				${ overlays }
				<a href="/${ item.route || '#' }" aria-label="${ title }">${ media }</a>
			</div>
		`;
	};

	/* --- new: the corner discount badge --- */
	Grid.get_discount_badge = function (item) {
		if (!item.discount) return ``;

		const value = String(item.discount).match(/[\d.]+\s*%/);
		const label = value ? `-${ value[0].replace(/\s/g, "") }` : String(item.discount);

		return `<div class="sf-badge-discount">${ label }</div>`;
	};

	/* --- body: title, category, price, stock, button --- */
	Grid.get_card_body_html = function (item, title, settings) {
		let html = `<div class="card-body">`;

		html += this.get_title(item, title);

		if (item.item_group) {
			html += `<div class="product-category" itemprop="name">${ item.item_group }</div>`;
		}
		if (item.formatted_price) {
			html += this.get_price_html(item);
		}

		html += this.get_stock_availability(item, settings);
		html += this.get_primary_button(item, settings);
		html += `</div>`;

		return html;
	};

	/* --- price: discount moved to the badge, so drop the inline "% OFF" --- */
	Grid.get_price_html = function (item) {
		let html = `
			<div class="product-price" itemprop="offers" itemscope
				itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

		if (item.formatted_mrp) {
			html += `<small class="striked-price"><s>${ item.formatted_mrp.replace(/ +/g, "") }</s></small>`;
		}

		return html + `</div>`;
	};

	/* --- stock: say so when it IS in stock, not only when it isn't --- */
	Grid.get_stock_availability = function (item, settings) {
		if (!settings.show_stock_availability || item.has_variants) return ``;

		if (item.on_backorder) return `<div class="has-stock">${ __("Available on backorder") }</div>`;
		if (!item.in_stock) return `<div class="out-of-stock">${ __("Out of stock") }</div>`;
		return `<div class="has-stock">${ __("In stock") }</div>`;
	};

	/* --- search: pass ?search= through to the product query --- */
	if (webshop.ProductView) {
		const View = webshop.ProductView.prototype;
		const upstream_filters = View.get_query_filters;

		View.get_query_filters = function () {
			const args = upstream_filters.call(this);
			const search = frappe.utils.get_url_arg("search");

			if (search) args.search = search;
			return args;
		};
	}
})();
